export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20product%20flat%20lay%20photography%20featuring%20premium%20sneakers%20hoodies%20watches%20sunglasses%20and%20leather%20accessories%20arranged%20artfully%20on%20warm%20beige%20linen%20fabric%20soft%20golden%20hour%20lighting%20minimalist%20composition%20high%20end%20fashion%20still%20life%20professional%20commercial%20photography%20with%20shallow%20depth%20of%20field%20muted%20earth%20tones&width=1920&height=1080&seq=hero-kakobuy-2026-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet product finds background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm border border-background-200/40 mb-6">
          <i className="ri-verified-badge-line text-primary-500 text-sm"></i>
          <span className="text-xs font-medium text-foreground-700">Trusted Product Discovery Platform</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
          Kakobuy Spreadsheet - Discover The Best Product Finds, Reviews & Shopping Lists
        </h1>

        <p className="text-base md:text-lg text-background-50/90 max-w-[680px] mx-auto mb-8 leading-relaxed">
          Find updated Kakobuy spreadsheets featuring trending products, verified finds, detailed comparisons, and expert shopping guides. Save time and discover better products with organized product collections.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="#categories"
            className="w-full sm:w-auto px-7 py-3.5 text-sm font-semibold rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer shadow-sm"
          >
            Explore Kakobuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-7 py-3.5 text-sm font-semibold rounded-lg bg-background-50/90 text-foreground-900 hover:bg-background-50 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            View Latest Finds
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
          <div className="flex items-center gap-2 text-background-50/80 text-xs md:text-sm">
            <i className="ri-checkbox-circle-line text-primary-400"></i>
            <span>Updated Product Collections</span>
          </div>
          <div className="flex items-center gap-2 text-background-50/80 text-xs md:text-sm">
            <i className="ri-checkbox-circle-line text-primary-400"></i>
            <span>Detailed Comparison Guides</span>
          </div>
          <div className="flex items-center gap-2 text-background-50/80 text-xs md:text-sm">
            <i className="ri-checkbox-circle-line text-primary-400"></i>
            <span>Shopping Safety Information</span>
          </div>
          <div className="flex items-center gap-2 text-background-50/80 text-xs md:text-sm">
            <i className="ri-checkbox-circle-line text-primary-400"></i>
            <span>Community Recommended Finds</span>
          </div>
        </div>
      </div>
    </section>
  );
}